import React from 'react'
import PropTypes from 'prop-types'
import './DashboardGrid.scss'

/**
 * DashboardGrid - Responsive CSS grid layout for dashboard widgets
 *
 * @param {React.ReactNode} children - Grid items
 * @param {number} columns - Number of columns (1-4)
 * @param {string} gap - Gap size ('sm' | 'md' | 'lg')
 * @param {string} className - Additional CSS classes
 */
const DashboardGrid = ({
	children,
	columns = 3,
	gap = 'md',
	className = ''
}) => {
	const gridClass = [
		'dashboard-grid',
		`dashboard-grid--cols-${columns}`,
		`dashboard-grid--gap-${gap}`,
		className
	].filter(Boolean).join(' ')

	return (
		<div className={gridClass}>
			{children}
		</div>
	)
}

/**
 * DashboardGrid.Item - Grid item with span control
 */
const GridItem = ({
	children,
	colSpan = 1,
	rowSpan = 1,
	className = ''
}) => {
	const itemClass = [
		'dashboard-grid__item',
		colSpan > 1 ? `dashboard-grid__item--col-${colSpan}` : '',
		rowSpan > 1 ? `dashboard-grid__item--row-${rowSpan}` : '',
		className
	].filter(Boolean).join(' ')

	return (
		<div className={itemClass}>
			{children}
		</div>
	)
}

GridItem.propTypes = {
	children: PropTypes.node,
	colSpan: PropTypes.oneOf([1, 2, 3, 4]),
	rowSpan: PropTypes.oneOf([1, 2, 3]),
	className: PropTypes.string
}

DashboardGrid.Item = GridItem

DashboardGrid.propTypes = {
	children: PropTypes.node,
	columns: PropTypes.oneOf([1, 2, 3, 4]),
	gap: PropTypes.oneOf(['sm', 'md', 'lg']),
	className: PropTypes.string
}

export default DashboardGrid
